import React from 'react';
import { Col } from 'reactstrap';

// Aviso puramente visual: o campo "Semestre" nessas telas é sempre o semestre de DESTINO (pra
// onde o aluno está migrando), não o semestre que ele cursa hoje — isso já confundiu a Secretaria
// mais de uma vez (ex.: configurar pro "5º semestre" é pros alunos que hoje cursam o 4º). Não
// muda nenhuma regra, só deixa explícito o que a seleção feita realmente significa.
//
// Importante: NÃO usar o <Alert> do reactstrap aqui — a classe "alert" tem uma regra global em
// default.css (position: fixed !important; bottom: 0 !important) feita pro toast de sucesso/erro
// do sistema, e qualquer elemento com essa classe herda esse posicionamento fixo no rodapé da tela.
const AvisoSemestreDestino = ({ nomeCampoSemestre, options = [], valoresAtuais = {}, style = {} }) => {
    const valorSelecionado = valoresAtuais ? valoresAtuais[nomeCampoSemestre] : undefined;
    const opcaoSelecionada = options.find((opcao) => String(opcao.value) === String(valorSelecionado));
    const opcaoAtual = opcaoSelecionada
        ? options.find((opcao) => String(opcao.value) === String(Number(opcaoSelecionada.value) - 1))
        : null;

    // Sem semestre selecionado ainda (ou sem semestre anterior correspondente), não há o que
    // avisar — evita mostrar a caixa vazia/incompleta antes do usuário escolher algo.
    if (!opcaoSelecionada || !opcaoAtual) {
        return null;
    }

    return (
        <Col {...(style.col || { xs: 12 })} className="form-col">
            <div
                className="mb-3"
                style={{
                    fontSize: '0.9rem',
                    backgroundColor: '#fff3cd',
                    borderLeft: '4px solid #ffc107',
                    color: '#856404',
                    padding: '12px 15px',
                    borderRadius: '4px',
                }}
            >
                <strong>Atenção:</strong> Selecionando o <strong>{opcaoSelecionada.label} semestre</strong>, essa
                configuração vale para os alunos que <strong>hoje cursam o {opcaoAtual.label} semestre</strong> (no
                período letivo vigente).
            </div>
        </Col>
    );
};

export default AvisoSemestreDestino;
